export const PROJECT_CREATED_EVENT = 'dashboard:project-created';

export const notifyProjectCreated = (project) => {
  if (typeof window === 'undefined' || !project?.id) {
    return;
  }

  window.dispatchEvent(new CustomEvent(PROJECT_CREATED_EVENT, {
    detail: {
      project,
      projectId: project.id,
    },
  }));
};
